<template>
	<JBox class="s-pb-32">
		<!-- Info -->
		<JBox class="s-bg-white s-shadow s-overflow-hidden sm:s-rounded-lg">
			<JBox class="s-px-4 s-py-5 s-border-b s-border-gray-200 sm:s-px-6">
				<!-- REFACTOR:THEME should be refactored into JHeadline variant -->
				<JHeadline class="s-text-xl">
					{{ product.name || "---" }}
				</JHeadline>
			</JBox>

			<!-- Info -->
			<JBox class="s-px-4 s-py-5 sm:s-p-0">
				<dl class="">
					<JBox class="sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-px-6 sm:s-py-5">
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							{{ $t("products.name") }}
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ product.name }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							{{ $t("products.insurer") }}
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ product && product.insurer && product.insurer.name }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							{{ $t("products.plan") }}
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ product.productId && product.productId.plan }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							{{ $t("products.type") }}
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ product.productId && product.productId.type }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">
							{{ $t("products.version") }}
						</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							{{ product.productId && product.productId.version }}
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">{{ $t("products.created") }}</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							<JText>{{ product.formattedCreatedAt }}</JText>
							<JText class="s-text-gray-500">{{ product.createdBy && product.createdBy.username }}</JText>
						</dd>
					</JBox>
					<JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">{{ $t("products.updated") }}</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							<JText>{{ product.formattedLastModifiedAt }}</JText>
							<JText class="s-text-gray-500">{{ product.lastModifiedBy && product.lastModifiedBy.username }}</JText>
						</dd>
					</JBox>
					<!-- <JBox
						class="s-mt-8 sm:s-mt-0 sm:s-grid sm:s-grid-cols-3 sm:s-gap-4 sm:s-border-t sm:s-border-gray-200 sm:s-px-6 sm:s-py-5"
					>
						<dt class="s-text-sm s-leading-5 s-font-medium s-text-gray-500">Last Release</dt>
						<dd class="s-mt-1 s-text-sm s-leading-5 s-text-gray-900 sm:s-mt-0 sm:s-col-span-2">
							20/12/2019
							<JText class="s-mt-2 s-text-yellow-400">
								Product has been changed but the latest changes are not released in the production environment yet.
							</JText>
						</dd>
					</JBox> -->
				</dl>
				<slot />
			</JBox>
		</JBox>

		<!-- Configuration -->
		<JBox class="s-mt-6">
			<JBox class="s-bg-white s-shadow s-overflow-hidden sm:s-rounded-md s-max-w-3xl s-m-auto s-mt-10">
				<ul class="">
					<li v-for="(item, i) in configurationList" :key="i">
						<RouterLink
							:to="item.to"
							class="s-block hover:s-bg-gray-50 focus:s-outline-none focus:s-bg-gray-50 s-transition s-duration-150 s-ease-in-out s-border-b s-border-gray-200"
						>
							<JBox class="s-px-4 s-py-4 s-flex s-items-center sm:s-px-6">
								<JBox class="s-min-w-0 s-flex-1 sm:s-flex sm:s-items-center sm:s-justify-between">
									<JBox class="">
										<JBox class="s-leading-5 s-font-medium s-text-indigo-600 s-truncate">
											{{ item.label }}
										</JBox>
										<JBox class="s-mt-1 s-flex">
											<JBox class="s-flex s-items-center s-text-sm s-leading-5 s-text-gray-500">
												{{ item.description }}
											</JBox>
										</JBox>
									</JBox>
									<JBox class="s-mt-4 s-flex-shrink-0 sm:s-mt-0">
										<JBox class="s-flex s-overflow-hidden">
											<JButton variant="default-sm">{{ item.buttonText }}</JButton>
										</JBox>
									</JBox>
								</JBox>
							</JBox>
						</RouterLink>
					</li>
				</ul>
			</JBox>
		</JBox>
	</JBox>
</template>

<script>
export default {
	data() {
		return {
			showUpdateModal: false,
			showDeleteModal: false
		}
	},

	computed: {
		configurationList() {
			return [
				// HACK: for travel productId.type we are redirecting to specific view, for others we redirect to logicEditor
				{
					label: "Pricing",
					description: "Define rules for pricing",
					buttonText: "Open Editor",
					isActive: true,
					to: {
						name: "ViewProductsPricing",
						params: this.$route.params
					}
				},
				{
					label: "Underwriting",
					description: "Define rules for underwriting",
					buttonText: "Open Editor",
					isActive: false,
					to: {
						name: "ViewProductsUnderwriting",
						params: this.$route.params
					}
				},
				{
					label: "Benefits",
					description: "Define product benefits structure",
					buttonText: "Manage",
					isActive: false,
					to: { name: "ViewProductsBenefits", params: this.$route.params }
				},
				{
					label: "Discount Codes",
					description: "Manage discount codes",
					buttonText: "Manage",
					isActive: false,
					to: { name: "ViewProductsDiscountsCodes", params: this.$route.params }
				},
				{
					label: "Loading Codes",
					description: "Manage loading codes",
					buttonText: "Manage",
					isActive: false,
					to: { name: "ViewProductsLoadingsCodes", params: this.$route.params }
				}
			]
		},
		product() {
			return this.$store.state?.products?.detail?.product ?? {}
		},
		type() {
			return this.product?.productId?.type
		},
		plan() {
			return this.product?.productId?.plan
		},
		version() {
			return this.product?.productId?.version
		}
	}
}
</script>
